import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ApiVersions,
  CashierConfiguration,
  ColourThemes,
  Directions,
  SubmitInitiators,
  UiVersions,
  Versions,
} from '@cashier/cashier-model';

export const CASHIER_CONFIGURATION_FEATURE_KEY = 'cashierConfiguration';

export const initialCashierConfigurationState: CashierConfiguration = {
  paymentType: null,
  amount: null,
  initialAmount: null,
  bonus: null,
  location: '',
  country: null,
  currency: null,
  customerBalance: null,
  direction: Directions.Ltr,
  host: null,
  language: null,
  merchantId: null,
  orderId: null,
  platform: null,
  sessionId: null,
  submitInitiator: SubmitInitiators.Self,
  termsUrl: null,
  theme: ColourThemes.Dark,
  userId: null,
  webView: false,
  notifyCustomerAboutPaymentResult: false,
  version: Versions.v2,
  cashierFieldUrl: '',
  apiVersion: ApiVersions.v1,
  uiVersion: UiVersions.v1,
};

export const cashierConfigurationSlice = createSlice({
  name: CASHIER_CONFIGURATION_FEATURE_KEY,
  initialState: initialCashierConfigurationState,
  reducers: {
    initialiseCashierConfiguration: (
      state,
      action: PayloadAction<CashierConfiguration>,
    ) => {
      const newConfiguration = {};

      Object.keys(action.payload).forEach((key) => {
        newConfiguration[key] =
          action.payload[key] || initialCashierConfigurationState[key];
      });
      state = { ...state, ...newConfiguration };

      return state;
    },
  },
});

export const cashierConfigurationReducer = cashierConfigurationSlice.reducer;

export const { initialiseCashierConfiguration } =
  cashierConfigurationSlice.actions;
